import React from 'react'
import PropTypes from 'prop-types'
import { Button, Dialog, Tab, Tabs } from '@chilecompra/react-kit/components'
import {
  DialogDescription,
  DialogItem,
  DialogList,
  DialogTitle,
  GridContainer,
  GridItem,
  Strong
} from './DownloadOrdersAndBiddingsSection.styles'

/**
 * The PreviewDialog's component.
 */
const PreviewDialog = props => {
  const { open, origin, onClose } = props

  return (
    <Dialog maxWidth="800px" open={open} onClose={onClose}>
      <GridContainer padding="32px 4px 16px">
        <GridItem xs={12}>
          <DialogTitle>Reporte descargable</DialogTitle>
        </GridItem>
      </GridContainer>
      <GridContainer padding="0 4px 17px">
        <GridItem xs={12}>
          <DialogDescription>
            Los reportes están compuestos por columnas de datos variables, son archivos en formato .csv con{' '}
            {origin === 'massive' && <Strong>datos mensuales</Strong>}
            {origin === 'reports' && <Strong>datos semestrales</Strong>}
          </DialogDescription>
        </GridItem>
      </GridContainer>
      <GridContainer>
        <GridItem xs={12}>
          <Tabs value="orders">
            <Tab id="orders" label="órdenes de compra">
              <GridContainer padding="0 0 14px">
                <GridItem xs={12}>
                  {origin === 'massive' && (
                    <DialogDescription>
                      El reporte de órdenes de compra está compuesto por columnas de datos comunes a cada modalidad de
                      compra. Dentro de las columnas de datos más importantes del reporte se encuentran:
                    </DialogDescription>
                  )}
                  {origin === 'reports' && (
                    <DialogDescription>
                      El reporte de órdenes de compra cuenta con columnas específicas dependiendo de la modalidad de
                      compra. Dentro de las columnas de datos más importantes del reporte se encuentran:
                    </DialogDescription>
                  )}
                </GridItem>
              </GridContainer>
              <GridContainer>
                <GridItem xs={2} />
                {origin === 'massive' && (
                  <GridItem xs={4}>
                    <DialogList>
                      <DialogItem>Codigo</DialogItem>
                      <DialogItem>FechaEnvio</DialogItem>
                      <DialogItem>Estado</DialogItem>
                      <DialogItem>DescripcionTipoOC</DialogItem>
                      <DialogItem>TipoMonedaOC</DialogItem>
                      <DialogItem>MontoTotalOC</DialogItem>
                    </DialogList>
                  </GridItem>
                )}
                {origin === 'massive' && (
                  <GridItem xs={4}>
                    <DialogList>
                      <DialogItem>ImpuestosOC</DialogItem>
                      <DialogItem>CodigoLicitacion</DialogItem>
                      <DialogItem>UnidadCompra</DialogItem>
                      <DialogItem>NombreProveedor</DialogItem>
                      <DialogItem>CodigoProductoONU</DialogItem>
                      <DialogItem>TotalLineaNeto</DialogItem>
                    </DialogList>
                  </GridItem>
                )}
                {origin === 'reports' && (
                  <GridItem xs={4}>
                    <DialogList>
                      <DialogItem>CodigoOC</DialogItem>
                      <DialogItem>FechaEnvioOC</DialogItem>
                      <DialogItem>EstadoOC</DialogItem>
                      <DialogItem>ProcedenciaOC</DialogItem>
                      <DialogItem>MonedaOC</DialogItem>
                      <DialogItem>MontoOC</DialogItem>
                    </DialogList>
                  </GridItem>
                )}
                {origin === 'reports' && (
                  <GridItem xs={4}>
                    <DialogList>
                      <DialogItem>ImpuestosOC</DialogItem>
                      <DialogItem>MetodoPago</DialogItem>
                      <DialogItem>UnidadCompra</DialogItem>
                      <DialogItem>Proveedor</DialogItem>
                      <DialogItem>ONUProducto</DialogItem>
                      <DialogItem>MontoTotalItem</DialogItem>
                    </DialogList>
                  </GridItem>
                )}
                <GridItem xs={2} />
              </GridContainer>
            </Tab>
            <Tab id="biddings" label="licitaciones">
              <GridContainer padding="0 0 14px">
                <GridItem xs={12}>
                  <DialogDescription>
                    El reporte de licitaciones está compuesto por columnas de datos que incorporan información del
                    proceso de ofertas. Dentro de las columnas de datos más importantes del reporte se encuentran:
                  </DialogDescription>
                </GridItem>
              </GridContainer>
              <GridContainer>
                <GridItem xs={2} />
                {origin === 'massive' && (
                  <GridItem xs={4}>
                    <DialogList>
                      <DialogItem>CodigoExterno</DialogItem>
                      <DialogItem>Tipo de Adquisicion</DialogItem>
                      <DialogItem>FuenteFinanciamiento</DialogItem>
                      <DialogItem>FechaPublicacion</DialogItem>
                      <DialogItem>FechaAdjudicacion</DialogItem>
                      <DialogItem>Estado</DialogItem>
                    </DialogList>
                  </GridItem>
                )}
                {origin === 'massive' && (
                  <GridItem xs={4}>
                    <DialogList>
                      <DialogItem>NombreUnidad</DialogItem>
                      <DialogItem>Nombre producto generico</DialogItem>
                      <DialogItem>NombreProveedor</DialogItem>
                      <DialogItem>Nombre de la Oferta</DialogItem>
                      <DialogItem>CantidadAdjudicada</DialogItem>
                      <DialogItem>Oferta seleccionada</DialogItem>
                    </DialogList>
                  </GridItem>
                )}
                {origin === 'reports' && (
                  <GridItem xs={4}>
                    <DialogList>
                      <DialogItem>NroLicitacion</DialogItem>
                      <DialogItem>TipoLicitacion</DialogItem>
                      <DialogItem>FuenteFinanciamiento</DialogItem>
                      <DialogItem>FechaPublicacion</DialogItem>
                      <DialogItem>FechaAdjudicacion</DialogItem>
                      <DialogItem>EstadoLicitacion</DialogItem>
                    </DialogList>
                  </GridItem>
                )}
                {origin === 'reports' && (
                  <GridItem xs={4}>
                    <DialogList>
                      <DialogItem>UnidadCompra</DialogItem>
                      <DialogItem>ONUProducto</DialogItem>
                      <DialogItem>Proveedor</DialogItem>
                      <DialogItem>NombreOferta</DialogItem>
                      <DialogItem>MontoTotalOferta</DialogItem>
                      <DialogItem>ResultadoOferta</DialogItem>
                    </DialogList>
                  </GridItem>
                )}
                <GridItem xs={2} />
              </GridContainer>
            </Tab>
          </Tabs>
        </GridItem>
      </GridContainer>
      <GridContainer padding="0 4px">
        <GridItem align="center" padding="0 0 28px" xs={12}>
          <Button color="default" onClick={onClose}>
            Cerrar
          </Button>
        </GridItem>
      </GridContainer>
    </Dialog>
  )
}

PreviewDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  origin: PropTypes.oneOf(['massive', 'reports']),
  onClose: PropTypes.func.isRequired
}

export default PreviewDialog
